/**
 * The procurement card's pure half - what a row says, with no React, so it can
 * be tested on its own.
 */
import type { ArProcurementWin } from "../../../../lib/procurement";
import { fmtMoney, fmtNum } from "../../../ui/format";

/**
 * The line an operator reads first.
 *
 * The lot, when the procurement was split into lots and the lot has a name of
 * its own: "Hooldus" under a procurement called "Siseveebi arendus ja hooldus"
 * is the part this company actually won. A single-lot procurement repeats its
 * title as the lot's, and then the title is said once.
 */
export function winHeadline(w: ArProcurementWin): string {
  if (w.lotTitle && w.lotTitle !== w.title) return w.lotTitle;
  return w.title ?? w.lotTitle ?? w.contractTitle ?? "";
}

/** The procurement's title under a lot headline, or null when the headline already is it. */
export function winContext(w: ArProcurementWin): string | null {
  return w.lotTitle && w.title && w.lotTitle !== w.title ? w.title : null;
}

/**
 * The amount as the row prints it, or null when the buyer withheld it.
 *
 * Null rather than "0 €": a withheld value is not a free contract, and a zero
 * on the row would read as one. A currency other than the euro keeps its own
 * code instead of being dressed as euros - every notice measured so far is in
 * EUR, which is exactly why a stray one must not pass unnoticed.
 */
export function winAmount(w: ArProcurementWin): string | null {
  if (w.amountCents == null) return null;
  if (w.currency && w.currency !== "EUR") return `${fmtNum(Math.round(w.amountCents / 100))} ${w.currency}`;
  return fmtMoney(w.amountCents);
}
